import { get } from './get';

export const tasks = {
  get,
};
